module.exports = __webpack_public_path__ + "img/album-3D-viewer.0998d6e7.svg";